module.exports = __webpack_public_path__ + "img/Refresh.e4722a33.svg";